export default "__VITE_ASSET__DNdfUhwn__"